export default "__VITE_ASSET__BMoO7m8e__"